module.exports = __webpack_public_path__ + "assets/img/Currency1.0c95bcb3.png";